import React, {
    useEffect, useState, useCallback, useContext, useMemo
} from 'react';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { LoaderExt } from 'gw-components-platform-react';
import metadata from './SafetyResources.metadata.json5';
import messages from './SafetyResources.messages';
import styles from './SafetyResources.module.scss';
import buttonStyles from '@jutro/components/Button/Button.module.css'
import useGoogleAnalytics from '../../hooks/useGoogleAnalytics';
import { withRouter } from 'react-router-dom';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { PolicyService } from 'gw-capability-policy';
import { EnrollmentService } from 'gw-capability-policyenrollment';

function SafetyResources(props) {
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const auth = useAuthentication();
    const [trackGAPageView] = useGoogleAnalytics();
    const authorizedGroups = ['useradmin']
    const [activePolicies, setActivePolicies] = useState(null)
    const [profileRefreshed, setProfileRefreshed] = useState(null)
    const [zywaveLink,setZywaveLink] = useState('')
    const [safetySourceLink,setSafetySourceLink] = useState('')
    // const { producerCodeList, producerCode, setProducerCode,unSortedProducerCodeList,multiInvoiceDropDown,
    //         setMultiInvoiceDropDown } = useContext(ProducerContext);

    const showExternalLinks = () => {
        for (const authority of auth.userInfo.grantedAuthorities) {
            const authorityRegex = /^guidewire\.edge\.(.*)\.(.*)\.(.*)$/g;
            const match = authorityRegex.exec(authority);
            if (authorizedGroups.includes(match[match.length-1])) {
                return true
            }
        }

        return false
    }

    useEffect(() => {
        trackGAPageView("/safety-resources", "Safety Resources")
    }, [])

    const checkForActivePolicies = useCallback(() =>{
        PolicyService.getAllAvailableAccountPolicySummaries_Ext(authHeader).then((policyData) => {
            if(policyData){
                let showFlag=0;
                for (let i = 0; i < policyData.length; i++) {
                    if (policyData[i].displayStatus === "In Force" || policyData[i].displayStatus === "Scheduled" || policyData[i].displayStatus === "Pending Cancellation") {                        
                        setActivePolicies(true);
                        return;
                    }
                }
            }
            setActivePolicies(false);
        }).catch(() => {
            
        });
    },[authHeader]);

    const refreshProfile = useCallback(() =>{
        EnrollmentService.refreshSafetyResourcesSSO(authHeader).then((result) => {
            let props = Object.keys(result)

            setProfileRefreshed(props.length > 0)
            if (props.length > 0) {
                setZywaveLink(result.zywave)
                setSafetySourceLink(result.safetySource)
            }
        }).catch(() => {
            
        })
    },[authHeader]);


    useEffect(() => {
        checkForActivePolicies()
        refreshProfile()
    },[])

    const overrideProps = {
        linksContainer: {
            visible: activePolicies && profileRefreshed,
        },
        ZywaveLink: {
            href: zywaveLink
        },
        SafetySourceLink: {
            href: safetySourceLink
        }
        // SafetySourceLinkContainer: {
        //     visible: activePolicies && profileRefreshed,
        // },
        // globalizationChooserField: {
        //     languageValue: localeService.getStoredLanguage(),
        //     availableLanguageValues: localeService.getAvailableLanguages(),
        // },
        // ...generatedProps
    };

    const styles_combo = { ...styles, ... buttonStyles}

    const resolvers = {
        resolveClassNameMap: styles_combo,
        resolveCallbackMap: {
            // enterEditMode,
            // handleCancel,
            // updateContactDetails,
            // onValidate,
            // updateLanguage: localeService.saveLanguage,
            // handleValueChange
        },
        resolveComponentMap: {
            // userdetailscomponent: UserDetailsComponent,
            // AccountDropDownValues: AccountDropDownValues
        }
    };

    // if (displayLoader) {
    //     return <LoaderExt />;
    // }

    if (activePolicies === null || profileRefreshed === null) {
        return <LoaderExt />;
    }

    return (
        <MetadataContent 
            uiProps={metadata.pageContent} overrideProps={overrideProps} {...resolvers} />
    );
}

export default withRouter(SafetyResources);